export default __webpack_public_path__ + "content/media/34.4e0e8086.jpg";